module.exports = __webpack_public_path__ + "r-v3/img/ico_menu_hidden_arrow_white.bf762609.svg";